import { NextPageContext } from 'next';
import Head from 'next/head';
import { generateSimpleStructuredData } from 'common/utils';
import { generateCookieList } from 'common/utils/trackingTag';
import AboutPageLayout from 'components/v2/layouts/about-page-layout';
import ChannelsSection from 'components/v2/modules/about-lp/channels-section';
import CreatorsSection from 'components/v2/modules/about-lp/creators-section';
import FeaturesSection from 'components/v2/modules/about-lp/features-section';
import HeroSection from 'components/v2/modules/about-lp/hero-section';
import IzanaviSection from 'components/v2/modules/about-lp/izanavi-section';
import MembershipSection from 'components/v2/modules/about-lp/membership-section';
import StickyTabs from 'components/v2/modules/about-lp/sticky-tabs';
import WhyPostPrimeSection from 'components/v2/modules/about-lp/why-postprime-section';
import { parse } from 'cookie';

const AboutPage = () => {
  const metadata = {
    title: 'PostPrimeとは | お金と投資の情報プラットフォーム',
    description:
      '専門家と投資家が集まり、質の高い情報を共有し合う新しいSNSプラットフォーム。日本株、米国株、暗号資産、コモディティの市場分析を毎日配信。50万人が選ぶPostPrimeで、今日から投資を始めよう。',
    image: 'https://assets.postprime.com/internals/pp_og.png',
    url: 'https://postprime.com/about',
    keywords:
      'PostPrime, 投資プラットフォーム, 投資SNS, 金融情報, 日本株, 米国株, 暗号資産, コモディティ, 投資コミュニティ, クリエイター, ライブ配信, 市場分析, IZANAVI, メンバーシップ',
  };

  return (
    <>
      <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={metadata.url} />
        <meta property="og:title" content={metadata.title} />
        <meta property="og:description" content={metadata.description} />
        <meta property="og:image" content={metadata.image} key="og:image" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content={metadata.title} />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={metadata.url} />
        <meta property="twitter:title" content={metadata.title} />
        <meta property="twitter:description" content={metadata.description} />
        <meta property="twitter:image" content={metadata.image} />

        <meta name="keywords" content={metadata.keywords} />
        <link rel="canonical" href={metadata.url} />

        {/* JSON-LD Structured Data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: generateSimpleStructuredData(metadata),
          }}
        />
      </Head>
      <AboutPageLayout>
        <HeroSection />
        <StickyTabs />
        <FeaturesSection />
        <WhyPostPrimeSection />
        <CreatorsSection />
        <ChannelsSection />
        <MembershipSection />
        <IzanaviSection />
      </AboutPageLayout>
    </>
  );
};

export const getServerSideProps = (context: NextPageContext) => {
  const cookiesList = generateCookieList(
    context.query,
    parse(context.req?.headers?.cookie || ''),
  );
  if (cookiesList.length > 0) {
    context.res.setHeader('Set-Cookie', cookiesList);
  }
  return {
    props: {},
  };
};

export default AboutPage;
